module.exports = __webpack_public_path__ + "static/img/JL_Portrait2.8878128.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/JL_Portrait2.jpg
// module id = DeVu
// module chunks = 1